<template>
	<div class="border border-gray-400 lg:flex rounded overflow-hidden bg-white p-2">
		<div
			class="flex w-full"
			:class="horizontal ? 'flex-row' : 'flex-col'"
		>
			<slot name="header"></slot>
			<slot></slot>
			<slot
				:class="horizontal ? 'horizontal-footer' : ''"
				name="footer"
			>
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "RpCard",
	props: {
		horizontal: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style>
.horizontal-footer {
	margin-right: auto;
}
</style>